import { render, staticRenderFns } from "./AddOrUpdateMemberProfileModal.vue?vue&type=template&id=553a575e"
import script from "./AddOrUpdateMemberProfileModal.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateMemberProfileModal.vue?vue&type=script&lang=js"
import style0 from "./AddOrUpdateMemberProfileModal.vue?vue&type=style&index=0&id=553a575e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports